import React, { Component } from "react";
import cx from "classnames";

const Block = ({ children }) => <ul className="c-timeline">{children}</ul>;

const Item = ({ left, right, big }) => (
  <li className="c-timeline--item">
    {left ? (
      <div className="c-timeline--item--left">{React.createElement(left)}</div>
    ) : (
      <div className="c-timeline--item--left__empty" />
    )}
    <div className={cx("c-timeline--spine", { "c-timeline--spine__big": big })}>
      ia
    </div>
    {right ? (
      <div className="c-timeline--item--right">
        {React.createElement(right)}
      </div>
    ) : (
      <div className="c-timeline--item--right__empty" />
    )}
  </li>
);

const Text = ({ title, children }) => (
  <div className="c-timeline--text">
    <div className="c-timeline--text--title h2">{title}</div>
    <div className="c-timeline--text--body">{children}</div>
  </div>
);

const Picture = ({ title, src }) => (
  <div className="c-timeline--text">
    <div className="c-timeline--text--title h2">{title}</div>
    <div className="c-timeline--text--body">
      <img src={src} />
    </div>
  </div>
);

export default {
  Block,
  Item,
  Text,
  Picture
};



// WEBPACK FOOTER //
// ./src/organisms/Timeline.js